import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { EffectComposer, Bloom } from '@react-three/postprocessing';

const QuantumBackground = () => {
  const torusRef = useRef<THREE.Mesh>(null);
  const icosahedronRef = useRef<THREE.Mesh>(null);
  const octahedronRef = useRef<THREE.Mesh>(null);

  useFrame((state) => {
    const time = state.clock.getElapsedTime();

    if (torusRef.current) {
      torusRef.current.rotation.x = time * 0.3;
      torusRef.current.rotation.y = time * 0.2;
      torusRef.current.position.y = Math.sin(time * 0.5) * 0.5;
    }

    if (icosahedronRef.current) {
      icosahedronRef.current.rotation.x = -time * 0.2;
      icosahedronRef.current.rotation.y = time * 0.3;
      icosahedronRef.current.position.y = Math.cos(time * 0.4) * 0.3;
    }

    if (octahedronRef.current) {
      octahedronRef.current.rotation.x = time * 0.4;
      octahedronRef.current.rotation.z = time * 0.2;
      octahedronRef.current.position.y = Math.sin(time * 0.6) * 0.4;
    }
  });

  return (
    <>
      {/* Torus */}
      <mesh ref={torusRef} position={[-3, 0, -2]}>
        <torusGeometry args={[1, 0.3, 16, 100]} />
        <meshStandardMaterial
          color="#00d9ff"
          emissive="#00d9ff"
          emissiveIntensity={0.5}
          transparent
          opacity={0.6}
          wireframe
        />
      </mesh>

      {/* Icosahedron */}
      <mesh ref={icosahedronRef} position={[3, 0, -1]}>
        <icosahedronGeometry args={[1.2, 0]} />
        <meshStandardMaterial
          color="#39ff14"
          emissive="#39ff14"
          emissiveIntensity={0.5}
          transparent
          opacity={0.6}
          wireframe
        />
      </mesh>

      {/* Octahedron */}
      <mesh ref={octahedronRef} position={[0, 2, -3]}>
        <octahedronGeometry args={[0.8, 0]} />
        <meshStandardMaterial
          color="#a855f7"
          emissive="#a855f7"
          emissiveIntensity={0.5}
          transparent
          opacity={0.6}
          wireframe
        />
      </mesh>

      {/* Lighting */}
      <ambientLight intensity={0.3} />
      <pointLight position={[5, 5, 5]} intensity={0.8} color="#00d9ff" />
      <pointLight position={[-5, -5, -5]} intensity={0.5} color="#39ff14" />

      {/* Bloom Effect */}
      <EffectComposer>
        <Bloom luminanceThreshold={0.2} luminanceSmoothing={0.9} intensity={1.5} />
      </EffectComposer>
    </>
  );
};

export default QuantumBackground;
